/* src/data/landing.js */

export const FEATURES = [
  { icon: '⚡', color: 'green',  title: 'Simulação em 6 bancos simultâneos',  desc: 'Compare BRB, Santander, Itaú, Inter, Bradesco e Caixa em uma única simulação. Identifique automaticamente a melhor opção.' },
  { icon: '📊', color: 'blue',   title: 'Cálculos precisos com SAC',           desc: 'Amortização, juros, MIP, DFI e TGC calibrados com dados oficiais de cada banco. Tabela completa de parcelas mês a mês.' },
  { icon: '📄', color: 'purple', title: 'Exportação em PDF profissional',       desc: 'Gere relatórios comparativos e detalhados prontos para apresentar ao cliente. Com sua marca e identidade visual.' },
  { icon: '📈', color: 'orange', title: 'Gráficos de evolução',                 desc: 'Visualize a evolução de parcelas, saldo devedor e composição (juros, amortização, seguros) em gráficos interativos.' },
  { icon: '🏷️', color: 'rose',   title: 'Taxas atualizadas',                    desc: 'Escolha entre taxas padrão ou personalizadas por banco. Inclua taxas promocionais e condições especiais dos seus parceiros.' },
  { icon: '🔒', color: 'teal',   title: 'CET — Custo Efetivo Total',            desc: 'Cálculo completo do CET incluindo seguros, tarifas e todas as despesas do financiamento. Transparência total para o cliente.' },
];

export const STEPS = [
  { num: '1', title: 'Insira os dados',        desc: 'Valor do imóvel, valor financiado, prazo e data de nascimento do cliente. Selecione as taxas de cada banco.' },
  { num: '2', title: 'Compare os resultados',  desc: 'Visualize o comparativo entre todos os bancos com gráficos, tabelas detalhadas e indicador da melhor opção.' },
  { num: '3', title: 'Apresente ao cliente',   desc: 'Exporte o relatório em PDF personalizado com sua marca e envie diretamente ao cliente para fechar o negócio.' },
];

export const PRICING = [
  {
    name: 'Simulador',
    desc: 'Simulador web completo para seu time',
    // monthly: 197, annual: 157,
    features: ['Simulação em 6 bancos simultâneos', '100 Simulações', 'PDF com sua marca (white-label)', 'Gráficos e evolução comparativa', 'Taxas personalizáveis por banco', 'Suporte prioritário via WhatsApp'],
    btnStyle: 'outline',
  },
  {
    name: 'Simulador + Seu CRM',
    desc: 'Integre ao Bitrix24, Pipefy, HubSpot e mais',
    // monthly: 397, annual: 317,
    features: ['Tudo do Simulador', '200 Simulações', 'Integração com CRMs de mercado', 'Histórico de simulações por cliente', 'Relatórios de conversão', 'Suporte dedicado + onboarding'],
    btnStyle: 'primary', popular: true,
  },
  {
    name: 'Simulador + CRM SimulaBank',
    desc: 'Plataforma completa para crédito',
    // monthly: 597, annual: 477,
    features: ['Tudo do Simulador + Integrações', 'Simulações ilimitadas', 'CRM próprio para crédito imobiliário', 'Pipeline visual de negócios', 'Gestão de leads', 'Onboarding dedicado + API'],
    btnStyle: 'dark',
  },
];

export const TESTIMONIALS = [
  { text: '"Antes eu levava 30 minutos simulando banco por banco. Com o SimulaBank, apresento o comparativo completo em 2 minutos. Meus clientes ficam impressionados."', nome: 'Marcos Costa',   cargo: 'Correspondente Bancário — Brasília/DF', iniciais: 'MC', cor: '#3B82F6' },
  { text: '"O PDF personalizado com nossa marca elevou o nível das nossas apresentações. Fechamos 40% mais contratos depois que começamos a usar."',                       nome: 'Renata Pinheiro', cargo: 'Diretora — Assessoria de Crédito',      iniciais: 'RP', cor: '#8B5CF6' },
  { text: '"A precisão dos cálculos é impressionante. Os valores batem exatamente com os simuladores oficiais dos bancos. Confiança total para apresentar ao cliente."',   nome: 'André Lima',     cargo: 'Gerente Comercial — Imobiliária',       iniciais: 'AL', cor: '#14B8A6' },
];

export const BANKS_HERO = [
  { name: 'Inter',     pct: 65, cor: 'var(--accent)', value: 'R$ 3.842', best: true },
  { name: 'Caixa',     pct: 72, cor: '#005CA9',        value: 'R$ 4.120' },
  { name: 'BRB',       pct: 78, cor: '#003882',        value: 'R$ 4.385' },
  { name: 'Bradesco',  pct: 82, cor: '#CC092F',        value: 'R$ 4.510' },
  { name: 'Santander', pct: 86, cor: '#EC0000',        value: 'R$ 4.698' },
  { name: 'Itaú',      pct: 92, cor: '#FF6600',        value: 'R$ 5.024' },
];

export const FOOTER_COLS = [
  {
    title: 'Produto',
    links: [
      { label: 'Funcionalidades', to: '/#features' },
      { label: 'Preços',          to: '/#precos' },
      { label: 'API',             to: '/api' },
      { label: 'Changelog',       to: '/changelog' },
    ],
  },
  {
    title: 'Empresa',
    links: [
      { label: 'Sobre',     to: '/sobre' },
      { label: 'Blog',      to: '/blog' },
      { label: 'Contato',   to: '/contato' },
      { label: 'Carreiras', to: '/carreiras' },
    ],
  },
  {
    title: 'Suporte',
    links: [
      { label: 'Central de ajuda', to: '/ajuda' },
      { label: 'Documentação',     to: '/docs' },
      { label: 'Status',           to: '/status' },
      { label: 'WhatsApp',         to: '/whatsapp' },
    ],
  },
];

export const NAV_LINKS = [
  { id: 'features',      label: 'Funcionalidades' },
  { id: 'como-funciona', label: 'Como funciona' },
  { id: 'precos',        label: 'Preços' },
  { id: '/blog',         label: 'Blog' },
  { id: '/contato',      label: 'Contato' },
];

export const ICON_BG = {
  green:  'rgba(0,214,143,0.1)',
  blue:   'rgba(59,130,246,0.1)',
  purple: 'rgba(139,92,246,0.1)',
  orange: 'rgba(245,166,35,0.1)',
  rose:   'rgba(244,63,94,0.1)',
  teal:   'rgba(20,184,166,0.1)',
};
